module.exports = __webpack_public_path__ + "static/progress5-4bbf393e889da09d4063dd10f0314c2d.png";